import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { EuiButton, EuiSpacer } from "@elastic/eui";
import Flyout from "components/Software/macOS/InstarVision/System_Requirements/sys-req_flyout";
import Table01 from "components/Software/macOS/InstarVision/Table01";
import ImageCard01 from "components/Software/macOS/InstarVision/instarVisionHorizontalCard01";
import ImageCard02 from "components/Software/macOS/InstarVision/instarVisionHorizontalCard02";
import ImageCard03 from "components/Software/macOS/InstarVision/instarVisionHorizontalCard03";
import MenuCard01 from "components/Software/macOS/InstarVision/instarVisionMenuCards01";
import MenuCard02 from "components/Software/macOS/InstarVision/instarVisionMenuCards02";
import MenuCard03 from "components/Software/macOS/InstarVision/instarVisionMenuCards03";
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Das InstarVision Sicherheit Center ist eine Kamera Software für die simultane Verwaltung von bis zu 64 Netzwerkkameras, USB Kameras oder Fernzugriffe auf Sekundärinstallationen der Software.",
  "image": "./P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <SEOHelmet title="InstarVision v3 für macOS" dateChanged="2018-01-25" author="Mike Polinowski" tag="INSTAR IP Camera" description="The InstarVision Surveillance Center is an IP camera software which can support 64 cameras at the same time, including Network cameras, USB cameras remotely accessed secondary installations of the software." image="/images/Search/P_SearchThumb_InstarVision_Windows.png" twitter="/images/Search/P_SearchThumb_InstarVision_Windows.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Software/macOS/InstarVision/" locationFR="/fr/Software/macOS/InstarVision/" crumbLabel="InstarVision v3" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#software",
        "aria-label": "software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software`}</h1>
    <h2 {...{
      "id": "macos",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#macos",
        "aria-label": "macos permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`macOS`}</h2>
    <h3 {...{
      "id": "instarvision-v3-für-macos",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#instarvision-v3-f%C3%BCr-macos",
        "aria-label": "instarvision v3 für macos permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`InstarVision v3 für macOS`}</h3>
    <p><strong parentName="p">{`Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.`}</strong></p>
    <p>{`Das InstarVision Überwachung Center erlaubt es Ihnen ein Auge auf Ihr Zuhause zu wahren - auch von Unterwegs. Verwandeln Sie Ihren PC in eine Videoüberwachung Station und kontrollieren Sie Ihre Pan, Tilt & Zoom Kameras aus der Ferne. Leiten Sie einen RTSP Video Stream Ihrer Kamera ins Internet und binden Sie diesen mit einem Video Plugin in Ihre Webseite ein - oder Nutzen Sie den pluginfreien JPG Stream aus sich ständig aktualisierenden Einzelbildern. Der erweiterte Bewegungserkennungsalgorithmus kann Sie im Falle eines Alarms per Email benachrichtigen und eine kurzes Video des Ereignisses aufzeichnen. Weitere Features sind eine feinstufige Benutzerverwaltung, eine interaktive elektronische Karten Funktion und ein eigenständiger Multikanal Video Player, der Ihnen ein schnelles Durchsuchen Ihrer Aufzeichnungen erlaubt.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a308d25c8df5141b14562a303aebd351/ad00e/Image002.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAC9klEQVQozy3OXVfaBQDH8f+agAiC/J/4y5PAcDIIhI2paDvHZc4OuHL5hIrTqeVKYSmWRi7LDWtq3cyW2VkXncb2DrzzJdheQrvwBczO0bNuvp2xfle/q8/5CleSrThlEYeq4NRU3A47mirjVBUcqorX7UCRZUSbDVUSsUsimiy++YqMQa9jZXmZcrnMs3IZIRJspPasQEAT8btUnKIJyVKDUmfCaDRgNSkYdTqMVWeQjDq8khmPtRq1pgrFZEAQBL5YKvDX8+ccHBwgJGNhlOq3cNrM1Et1nPdoeD1e5Pp6RI+ExWjCZrUgW2rxqF7iTXHiDS58qohiMVfA7c1NXr485ujoCKGjvRWT3ohNlPD53Iz29zKRzRKNJXA3eJAstRgNehRTNUFXBIcWJp0M0dsewWGzclYQ+L5U4vX+OT5GSEQvoK86g8VqptHv4sf1r9leL5I45yCg1eFz2DDo9WhmHWHNTNAjc/niJTpbYqiitVJY+h88PT1FaL+Sxu4M4w8kiDZ3kk5lSKVGCAcTvB26zLnzMerqRDRbbQWQZBGPtwG7qqAocgV8sLlZAU9OThD6x7dIDT5keOJ3xj75g8z0Y7KzvzGbe8zo9C5d1/O4HAo+r4vGgI+WeJRIqAl/g4tEc4igv569Xx+9KXwNZsaLTN8qUpxfZeH2GvNzJVaLD8lM3eXO3ArdqSxWi4n2ZCt9H6ZJv5uk/70kVztaiEVCBDwae492KuC/r14hzOTXuP35Bj8sLrO28B235rbZKNxjZPgrcvm7DN24Qa25hkBjgPd7urme6mKgt4c7M6M0Ry4g2UXuPyjx4u8XHB4eIlxs66G9o597hRUGbm4xMvUTX+buMz2zQWffN3Sls4jWGhKtURbyI0xNfoA74KCvO86l5iaS19r4LP8pT/58ws7ODsJHmVkWJ0aZ/LhEfmmX1eWf2Vrf49vVXxjP7TIwuci17m7WF2fJTQ2RGRtkaGyQznfauJkdZn5pnkKhwP7+Ps+ePuU/gLubXiF3ljkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a308d25c8df5141b14562a303aebd351/e4706/Image002.avif 230w", "/de/static/a308d25c8df5141b14562a303aebd351/d1af7/Image002.avif 460w", "/de/static/a308d25c8df5141b14562a303aebd351/7f308/Image002.avif 920w", "/de/static/a308d25c8df5141b14562a303aebd351/148ae/Image002.avif 1366w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a308d25c8df5141b14562a303aebd351/a0b58/Image002.webp 230w", "/de/static/a308d25c8df5141b14562a303aebd351/bc10c/Image002.webp 460w", "/de/static/a308d25c8df5141b14562a303aebd351/966d8/Image002.webp 920w", "/de/static/a308d25c8df5141b14562a303aebd351/ec897/Image002.webp 1366w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a308d25c8df5141b14562a303aebd351/81c8e/Image002.png 230w", "/de/static/a308d25c8df5141b14562a303aebd351/08a84/Image002.png 460w", "/de/static/a308d25c8df5141b14562a303aebd351/c0255/Image002.png 920w", "/de/static/a308d25c8df5141b14562a303aebd351/ad00e/Image002.png 1366w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a308d25c8df5141b14562a303aebd351/c0255/Image002.png",
              "alt": "InstarVision v3 für macOS",
              "title": "InstarVision v3 für macOS",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "übersicht",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%C3%BCbersicht",
        "aria-label": "übersicht permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Übersicht`}</h2>
    <p>{`Wenn Sie das InstarVision Überwachung Center starten werden Sie von der folgenden grafischen Oberfläche (GUI) begrüßt. Die linke Fläche der UI ist der Video Canvas. Rechts finden Sie die Seitennavigation der Software. Letztere kann jederzeit zur Seite geschoben werden, um den Bereich, den Ihre Kameras einnehmen, zu maximieren (Klicken Sie dafür auf der linken Seite der Navigationsleiste auf den Knopf zum Minimieren der Leiste). Maximieren Sie die GUI um Ihren Bildschirm zu füllen, minimieren Sie das Programm in den macOS Tray oder ziehen Sie die UI freihändische mit Ihrer Maus auf die gewünschte Größe. Klicken Sie auf Schließen um das Programm zu beenden und zum Windows Desktop zurückzukehren.`}</p>
    <ul>
      <li parentName="ul">{`Um eine Kamera hinzuzufügen, öffnen Sie bitte die `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Camera_List/"
        }}>{`Kamera Liste`}</a>{` und klicken Sie auf das + Icon unten rechts im Listenbereich.`}</li>
      <li parentName="ul">{`Die Software bietet Ihnen 3 Aufnahme Methoden. Sie können direkt auf das kleine Kamera Symbol oben rechts im `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Camera_List/"
        }}>{`Darstellungsfeld des Videokanals`}</a>{` klicken um eine manuelle Aufnahme zu starten oder zu beenden. Die Einstellungen für die `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/Schedule/"
        }}>{`Scheduled Recording`}</a>{` and `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/Alarm/"
        }}>{`Geplante Aufnahme`}</a>{` und `}<a parentName="li" {...{
          "href": ""
        }}>{`Alarmaufnahme`}</a>{` finden Sie im `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/"
        }}>{`Aufnahme Menü`}</a>{`.`}</li>
      <li parentName="ul">{`Die `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/Email/"
        }}>{`Email Benachrichtigung`}</a>{` und der `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/FTP/"
        }}>{`FTP Upload`}</a>{` im Falle eines Alarms können Sie im `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record/"
        }}>{`Aufnahme Menü`}</a>{` einstellen.`}</li>
    </ul>
    <h2 {...{
      "id": "systemvoraussetzungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#systemvoraussetzungen",
        "aria-label": "systemvoraussetzungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Systemvoraussetzungen`}</h2>
    <p>{`Zur besseren Übersicht der benötigten Ressourcen der InstarVision 2.0 haben wir in verschiedenen Szenarien die Software getestet und die Ergebnisse oben dargestellt. Als Test-System haben wir einen Mittelklasse-Rechner mit folgenden Daten genutzt:`}</p>
    <Flyout mdxType="Flyout" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "video-modus-standard-login-und-sprachauswahl",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#video-modus-standard-login-und-sprachauswahl",
        "aria-label": "video modus standard login und sprachauswahl permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Video Modus, Standard Login und Sprachauswahl`}</h2>
    <p><strong parentName="p">{`SOLLTE DAS VIDEO IHRER KAMERA SCHWARZ BLEIBEN`}</strong>{` obwohl Sie Video und Schnappschüsse aufnehmen können, kann es sein, dass ein Problem mit der Videoenkodierung auf Ihrer Videokarte vorherrscht. Öffnen Sie dann bitte das `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/System/"
      }}>{`System Menü`}</a>{` und schalten Sie das Yuy2 Video Encoding. Das Video der Kamera sollte korrekt dargestellt werden, nachdem Sie die Software neugestartet haben.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ImageCard01 mdxType="ImageCard01" />
    <EuiSpacer size="xxl" mdxType="EuiSpacer" />
    <Table01 mdxType="Table01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Um die `}<strong parentName="p">{`Sprache der UI`}</strong>{` zu ändern, öffnen Sie bitte das `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/System/"
      }}>{`System Menü`}</a>{` der Software. Wählen Sie danach die gewünschte Sprache aus dem ausklappbaren Menü.`}</p>
    <h2 {...{
      "id": "registrierung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#registrierung",
        "aria-label": "registrierung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Registrierung`}</h2>
    <p><strong parentName="p">{`Wenn Sie das Überwachung Center das erste Mal öffnen, werden Sie den folgenden Registrierungsdialog sehen:`}</strong></p>
    <p>{`Klicken Sie auf "Test Version" um die Software für 14 Tage kostenlos zu testen. Die Testversion der Software beinhaltet alle Funktionen, ist aber auf 16 Kanäle beschränkt! Nach dem Kauf der Software erhalten Sie einen Lizenzschlüssel, kopieren Sie diesen hier ein und klicken Sie auf Online Registrieren. Alternativ können Sie auch die Emailregistrierung nutzen um die Software freizuschalten - Klicken Sie dafür auf Generiere ID und senden Sie diese Datei an uns. Sie werden darauf von uns ein Token erhalten, mit dem Sie die `}<a href="https://www.instar.com/contact" target="_blank" rel="noopener noreferrer">{`Email Registrierung`}</a>{` durchführen können.`}</p>
    <EuiSpacer size="xxl" mdxType="EuiSpacer" />
    <ImageCard02 mdxType="ImageCard02" />
    <EuiSpacer size="xl" mdxType="EuiSpacer" />
    <h2 {...{
      "id": "seiten-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#seiten-navigation",
        "aria-label": "seiten navigation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Seiten Navigation`}</h2>
    <p><strong parentName="p">{`Die Seiten Navigation bietet Ihnen einen schnellen Zugriff auf alle Funktionen der Software. Insgesamt gibt es 10 Unterkategorien auf die Sie klicken können, um sich die zugehörigen Einstellungen anzeigen zu lassen:`}</strong></p>
    <EuiSpacer size="xxl" mdxType="EuiSpacer" />
    <ImageCard03 mdxType="ImageCard03" />
    <EuiSpacer size="xxl" mdxType="EuiSpacer" />
    <h2 {...{
      "id": "benutzeroberfläche",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#benutzeroberfl%C3%A4che",
        "aria-label": "benutzeroberfläche permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Benutzeroberfläche`}</h2>
    <MenuCard01 mdxType="MenuCard01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <MenuCard02 mdxType="MenuCard02" />
    <EuiSpacer mdxType="EuiSpacer" />
    <MenuCard03 mdxType="MenuCard03" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      